// Decompte de semaines du calendrier (cf planningApi.Decompte) : numero de
// chaque semaine, de SN (premiere semaine) a S1 (semaine cible).
import type { Decompte } from './planningApi.ts';
import { ajouterJours } from './dates.ts';

const JOUR_MS = 24 * 3600 * 1000;

/** Date locale d'une chaine AAAA-MM-JJ (a minuit). */
export function dateLocale(s: string): Date {
  const [a, m, j] = s.split('-').map(Number);
  return new Date(a, m - 1, j);
}

/** Lundi de la semaine d'une date. */
export function lundiDe(d: Date): Date {
  const r = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  return ajouterJours(r, -((r.getDay() + 6) % 7));
}

/** Nombre de semaines entre deux lundis (b - a). */
export function semainesEntre(a: string, b: string): number {
  return Math.round((dateLocale(b).getTime() - dateLocale(a).getTime()) / (7 * JOUR_MS));
}

/** Decompte couvrant la semaine d'un lundi et son numero (n de Sn), ou null. */
export function numeroSemaine(decomptes: Decompte[], lundi: string): { n: number; decompte: Decompte } | null {
  const d = decomptes.find((x) => x.lundiDebut <= lundi && lundi <= x.lundiCible);
  return d ? { n: semainesEntre(lundi, d.lundiCible) + 1, decompte: d } : null;
}

/** Decompte existant qui chevauche la periode debut -> cible (lundis), ou null. */
export function chevauchement(decomptes: Decompte[], debut: string, cible: string): Decompte | null {
  return decomptes.find((x) => debut <= x.lundiCible && x.lundiDebut <= cible) ?? null;
}
